import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './list.module.css'

const listItemPropTypes = {
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
    onClick: PropTypes.func
}

const ListItem = props => (
    <div className={cx(styles['list-item'], props.className)} onClick={props.onClick}>
        <div className={styles['content']}>{props.children}</div>
    </div>
)

ListItem.propTypes = listItemPropTypes

export default ListItem
